import {Field} from 'formik';

import {
    FormikCheckbox,
    FormikNumberInput,
    FormikSelect,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from '@mantine/core';
import {FormikList} from '../../../../components/FormikList';
import {ListRowElement} from '../../../../components/FormikList/types';
import {deploymentAccounts} from '../../config/accounts';


const getStageRowElements = (): ListRowElement[] => [
    {
        name: 'name',
        component: FormikTextInput,
        placeholder: 'Stage name',
        span: 4,
    },
    {
        name: 'order',
        component: FormikNumberInput,
        placeholder: 'Order',
        span: 2,
    },
    {
        name: 'buildProvider',
        component: FormikSelect,
        data: [
            {value: 'CODEBUILD', label: 'CodeBuild'},
        ],
        placeholder: 'Build Provider',
        span: 3,
    },
    {
        name: 'deployProvider',
        component: FormikSelect,
        data: [
            {value: 'CLOUDFORMATION', label: 'CloudFormation'},
            {value: 'CDK', label: 'CDK'},
            {value: 'S3', label: 'S3'},
        ],
        placeholder: 'Deploy Provider',
        span: 2,
    },
    {
        name: 'requiresApproval',
        component: FormikCheckbox,
        placeholder: 'Approval',
        span: 1,
    },
];

const accountSelectData = deploymentAccounts.map(account => ({
    value: account.accountId,
    label: `${account.accountName} (${account.accountId})`,
}));

const getDeploymentAccountRowElements = (): ListRowElement[] => [
    {
        name: 'accountId',
        component: FormikSelect,
        data: accountSelectData,
        placeholder: 'Select Account',
        span: 5,
    },
    {
        name: 'region',
        component: FormikSelect,
        data: [
            {value: 'us-east-1', label: 'US East (N. Virginia)'},
            {value: 'us-east-2', label: 'US East (Ohio)'},
            {value: 'us-west-1', label: 'US West (N. California)'},
            {value: 'us-west-2', label: 'US West (Oregon)'},
            {value: 'eu-west-1', label: 'EU (Ireland)'},
            {value: 'eu-central-1', label: 'EU (Frankfurt)'},
            {value: 'ap-southeast-1', label: 'Asia Pacific (Singapore)'},
            {value: 'ap-northeast-1', label: 'Asia Pacific (Tokyo)'},
        ],
        placeholder: 'Region',
        span: 7,
    },
];

export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Template Details'}>
                <Field
                    name='name'
                    label='Name'
                    description='Please enter the template name'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='Please enter template description'
                    component={FormikTextarea}
                    my={'xl'}
                />

                <Field
                    name='pipelineType'
                    label='Pipeline Type'
                    description='Please select the pipeline type'
                    component={FormikSelect}
                    data={[
                        {value: 'APPLICATION', label: 'Application'},
                        {value: 'API', label: 'API'},
                        {value: 'DATABASE', label: 'Database'},
                        {value: 'INFRASTRUCTURE', label: 'Infrastructure'},
                        {value: 'SERVICE', label: 'Service'},
                    ]}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='archetype'
                    label='Archetype'
                    description='Please select the pipeline archetype'
                    component={FormikSelect}
                    data={[
                        {value: 'CDK_INFRASTRUCTURE', label: 'CDK Infrastructure'},
                        {value: 'STATIC_SITE', label: 'Static Site'},
                        {value: 'API', label: 'API'},
                    ]}
                    my={'xl'}
                />

                <Field
                    name='buildCommand'
                    label='Build Command'
                    description='Please enter the build command'
                    component={FormikTextInput}
                    my={'xl'}
                />

            </PlatformFieldset>

            <PlatformFieldset legend={'Pipeline Stages'}>
                <Field
                    name='stages'
                    label='Stages'
                    description='Define the pipeline stages'
                    getRowElements={getStageRowElements}
                    component={FormikList}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Default Deployment Accounts'}>
                <Field
                    name='defaultDeploymentAccounts'
                    label='Deployment Accounts'
                    description='Define the default deployment accounts'
                    getRowElements={getDeploymentAccountRowElements}
                    component={FormikList}
                />
            </PlatformFieldset>

        </Stack>
    );
};
